import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { ConstraintTypeSelect } from "./constraintTypeSelect";
import { DeltaSelect } from "./deltaSelect";
import styles from "./styles.scss";

function ConstraintTypeForm({
  constraint,
  deltaOffset,
  editConstraint,
}: Props) {
  const { t } = useTranslation();
  const text = {
    START_START: "begins",
    END_END: "ends",
    START_END: "begins",
    END_START: "begins",
  };

  return (
    <div className={styles.constraintTypeForm}>
      <DeltaSelect
        delta={constraint.offsetDays}
        timeUnit={constraint.timeUnit}
        offset={deltaOffset}
        select={(delta, offset) =>
          editConstraint({ ...constraint, offsetDays: delta }, offset)
        }
        selectTimeUnit={(timeUnit) =>
          editConstraint({ ...constraint, timeUnit }, deltaOffset)
        }
      />
      <ConstraintTypeSelect
        type={constraint.constraintType}
        select={(constraintType) =>
          editConstraint({ ...constraint, constraintType }, deltaOffset)
        }
      />
      <p className={styles.text}>
        {t(
          `constraintTypeForm.${
            text[`${constraint.originDateType}_${constraint.targetDateType}`]
          }`,
        )}
      </p>
    </div>
  );
}

export { ConstraintTypeForm };
